import { post } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { twoFA as types } from 'types';

const twoFA = {
    generate() {
        return post<types.TTwoFA, null>(
            `${endpoints[EEndpoints.generate2FA]()}`,
            {},
        );
    },
    confirm(reqBody: types.TConfirmtwoFA) {
        return post<void, null>(`${endpoints[EEndpoints.confirm2FA]()}`, {
            ...reqBody,
        });
    },
};

export default twoFA;
